import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { initializeAuth } from '../../store/slices/authSlice';
import BlueMenu from './BlueMenu';
import ClassicMenu from './ClassicMenu';
import AIChatWidget from '../ai/AIChatWidget';

const DashboardLayout = ({ children, requiredRole = null, onNewLead }) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { menuLayout, greyMenuDisplayMode } = useSelector((state) => state.users);
  const { showGreyMenu: isGreyMenuVisible } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.profile?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  const isClassic = menuLayout === 'classic';

  // Classic layout: thin BlueMenu (64px) + optional GreyMenu (80/280px)
  const noGreyMenuPaths = ['/', '/weather', '/projects/calendar'];
  const shouldShowGreyMenu = isClassic && isGreyMenuVisible && !noGreyMenuPaths.includes(location.pathname);

  return (
    <div className="flex h-screen max-w-[100vw] overflow-hidden bg-[#f6f8fb]">
      {isClassic ? <ClassicMenu onNewLead={onNewLead} /> : <BlueMenu />}

      <main
        className={`flex-1 min-w-0 h-screen overflow-hidden flex flex-col transition-[margin] duration-300 ease-in-out
          ${isClassic && shouldShowGreyMenu
            ? greyMenuDisplayMode === 'icon' ? 'md:ml-[80px]' : 'md:ml-[280px]'
            : ''}`}
      >
        <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar pb-16 md:pb-0">
          {children}
        </div>
      </main>

      {location.pathname !== '/ai' && <AIChatWidget />}
    </div>
  );
};

export default DashboardLayout;
